import { render } from "./textAnswer.vue?vue&type=template&id=7430a14e&scoped=true"
import script from "./textAnswer.vue?vue&type=script&lang=js"
export * from "./textAnswer.vue?vue&type=script&lang=js"

import "./textAnswer.vue?vue&type=style&index=0&id=7430a14e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7430a14e"]])

export default __exports__